// Which eigen (Deccos) standaard an effect belongs to, keyed by its MSIId.
//
// A THIRD map next to standaardVersions.js and legacyStandaardVersions.js,
// because these effects are addressed differently. The other two resolve a
// SECTOR onto a standaard; these effects carry no sector at all (verified in
// production: all 15 Participatieladder effects have `sectors: []`), so the
// only stable handle is the effect's own MSIId.
//
// PROVENANCE — read before adding a key. Participatieladder 2026.1 was given by
// the product owner on 2026-08-28. It is an eigen standaard: it is versioned on
// our side, not by the meetstandaard party, so there is no API to check it
// against. A wrong number here silently mislabels every answer given under it.
//
// FOUR EFFECTS ARE DELIBERATELY ABSENT. Zelf-effectiviteit, Dagelijks
// functioneren, Maatschappelijke Participatie and Digitale vaardigheden sit in
// exactly the same position — no sector, no derivable standaard — and together
// hold 1.322 answers. They are left out because nobody has said which standaard
// and version they belong to. Guessing one is the failure this whole feature
// exists to prevent; add them once someone confirms.
//
// AI-CONTEXT: See docs/features/msi-version-stamping.md

/**
 * Effect MSIId → the eigen standaard and version it belongs to.
 * @type {Object<string, {standaard: string, standaardVersion: string}>}
 */
const INTERNAL_STANDAARD_VERSIONS = {
    // Participatieladder
    'ffba7445-7d2c-4a92-835c-9273c9a3478c': {
        standaard: 'participatieladder',
        standaardVersion: '2026.1',
    },
}

/**
 * Resolves an effect's MSIId onto the eigen standaard it belongs to.
 *
 * Returns null for anything not explicitly listed — never a default. An effect
 * that is not an eigen standaard must fall through to the sector-based maps.
 *
 * @param {string|undefined|null} msiId - MSIId of the EFFECT, not of a question
 * @returns {{standaard: string, standaardVersion: string}|null}
 */
const internalStandaardFor = (msiId) => {
    if (typeof msiId !== 'string' || msiId === '') return null
    // hasOwnProperty, not a plain lookup: an id like 'constructor' would
    // otherwise resolve to something off Object.prototype and get stamped.
    if (!Object.prototype.hasOwnProperty.call(INTERNAL_STANDAARD_VERSIONS, msiId)) return null
    return INTERNAL_STANDAARD_VERSIONS[msiId]
}

export default internalStandaardFor
export { INTERNAL_STANDAARD_VERSIONS }
